module.exports = __webpack_public_path__ + "static/media/urbangoo04.e85a019f.webp";